import React from "react";
import { useOnload } from "@utils/useOnLoad";
import { GradientWrapper, InnerContainer, Title, StatusText} from "./styles";

interface CoverageCardProps {
  is_visible: boolean;
  title?: string;
  statusText?: string;
  isActive?: boolean;
  actions?: any;
  styles?: any;
}

const PolicyStatusCard = ({ is_visible, title, statusText, isActive, actions, styles }: CoverageCardProps) => {
  const { on_load } = actions || {};

  useOnload({ on_load });

  const expiryVariant: "expired" | "active" = isActive === true ? "active" : "expired";

  return is_visible?(
    <GradientWrapper expiryVariant={expiryVariant} style={styles}>
      <InnerContainer expiryVariant={expiryVariant}>
        <Title>{title}</Title>
        <StatusText expiryVariant={expiryVariant}>{statusText}</StatusText>
      </InnerContainer>
    </GradientWrapper>
  ):null;
};

export default PolicyStatusCard; 